import React from 'react';
import { FMessage } from '../../../../hoc/IntlComponents';
import { array, func } from 'prop-types';
import FlowsListItem from './FlowsListItem';
import CustomTable from '../../../../components/CustomTable/CustomTable';

const propTypes = {
  flows: array.isRequired,
  onFlowRemove: func.isRequired,
};

const defaultProps = {
  flows: [],
};

const FlowsList = ({ flows, onFlowRemove, sortOrder, sortBy, handleSort }) => {
  return (
    <CustomTable className="flows-list" bordered responsive aria-label="Flows">
      <CustomTable.Wrapper>
        <CustomTable.Row>
          <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName="encId"
            handleSort={handleSort}
            defaultSortOrder="desc"
            sorting
          >
            ID
          </CustomTable.Cell>
          <CustomTable.Cell>
            <FMessage id="flows.table.click-link.theme_4" />
          </CustomTable.Cell>
          <CustomTable.Cell>
            <FMessage id="flow.form.direct-link-without-redirect.title" />
          </CustomTable.Cell>
          <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName="its"
            handleSort={handleSort}
            defaultSortOrder="desc"
            sorting
          >
            <FMessage id="flows.table.added.theme_4" />
          </CustomTable.Cell>

          <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName="title"
            handleSort={handleSort}
            defaultSortOrder="desc"
            sorting
          >
            <FMessage id="flows.table.title.theme_4" />
          </CustomTable.Cell>
          {/* <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName='type'
            handleSort={handleSort}
            defaultSortOrder='desc'
            sorting>
            <FMessage id="flows.table.type" />
          </CustomTable.Cell> */}
          <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName="offerTitle"
            handleSort={handleSort}
            defaultSortOrder="desc"
            sorting
          >
            <FMessage id="flows.table.offer" />
          </CustomTable.Cell>
          {/* <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName='siteTitle'
            handleSort={handleSort}
            defaultSortOrder='desc'
            sorting>
            <FMessage id="flows.table.source" />
          </CustomTable.Cell> */}
          <CustomTable.Cell />
          <CustomTable.Cell className="table-controls">
            <FMessage id="flows.table.controls" />
          </CustomTable.Cell>
          {/* <CustomTable.Cell className="table-controls" /> */}
        </CustomTable.Row>
      </CustomTable.Wrapper>

      {flows.length > 0 && (
        <CustomTable.Wrapper type="body">
          {flows.map(flow => (
            <FlowsListItem
              key={flow.id}
              {...flow}
              onFlowRemove={onFlowRemove}
              count={flows.length}
            />
          ))}
        </CustomTable.Wrapper>
      )}
    </CustomTable>
  );
};

FlowsList.propTypes = propTypes;
FlowsList.defaultProps = defaultProps;

export default FlowsList;
